var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Chip, Tab, Tabs, useMediaQuery } from '@mui/material';
var getHorizontalMenuTabStyles = function (variant) {
    switch (variant) {
        case 'box':
            return {
                container: boxContainerSx,
                tab: boxTabSx,
                tabs: boxTabsSx,
            };
        case 'minimal':
            return {
                container: minimalContainerSx,
                tab: minimalTabSx,
                tabs: minimalTabsSx,
            };
        case 'filter':
            return {
                container: filterContainerSx,
                tab: filterTabSx,
                tabs: filterTabsSx,
                tabIndicator: filterTabIndicatorSx,
            };
    }
};
export function HorizontalMenuTabs(_a) {
    var setValue = _a.setValue, tabs = _a.tabs, value = _a.value, chipConfig = _a.chipConfig, variant = _a.variant, disabledTabs = _a.disabledTabs;
    var isMediumScreen = useMediaQuery('(max-width: 1201px)');
    var styles = getHorizontalMenuTabStyles(variant);
    var handleChange = function (e, newValue) {
        e.preventDefault();
        setValue(newValue);
    };
    return (_jsxs(Box, { sx: styles.container, children: [_jsx(Tabs, { value: value === -1 ? 0 : value, onChange: handleChange, sx: styles.tabs, TabIndicatorProps: {
                    sx: styles.tabIndicator,
                }, children: tabs.map(function (t) { return (_jsx(Tab, { label: t, sx: styles.tab, disableRipple: true, disabled: disabledTabs === null || disabledTabs === void 0 ? void 0 : disabledTabs.includes(t) }, t)); }) }), chipConfig && (_jsx(Chip, { variant: "pill", size: "lg", type: isMediumScreen ? 'only' : 'leading', label: chipConfig.label, icon: chipConfig.iconName && (_jsx(AppIcon, { iconName: chipConfig.iconName, diameter: "12px", color: chipConfig.iconColor || 'Warning/500' })), sx: chipSx, onClick: chipConfig.onClick }))] }));
}
var minimalTabSx = function (_a) {
    var typography = _a.typography, backrs = _a.backrs;
    return (__assign(__assign({}, typography['text-md-semibold']), { textTransform: 'none', color: backrs.colors['Colors/Foreground/fg-brand-secondary'], '&.Mui-selected': {
            color: backrs.colors['Colors/Foreground/fg-brand-secondary'],
        }, '&:hover': {
            color: backrs.colors['Colors/Foreground/fg-brand-secondary'],
        } }));
};
var boxTabSx = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign(__assign({ border: "1px solid ".concat(backrs.colors['Gray/300']), '&:first-of-type': {
            borderRadius: '8px 0px 0px 8px',
        }, '&:last-of-type': {
            borderRadius: '0px 8px 8px 0px',
        } }, typography['text-sm-semibold']), { color: backrs.colors['Gray/700'], transition: 'all 0.3s ease-in-out', backgroundColor: backrs.colors['Colors/Background/bg-primary'], '&.Mui-selected': {
            backgroundColor: "".concat(backrs.colors['Colors/Background/bg-active']),
            color: backrs.colors['Gray/700'],
        }, '&:hover': {
            backgroundColor: "".concat(backrs.colors['Gray/50']),
            color: backrs.colors['Gray/700'],
        }, textTransform: 'none' }));
};
var minimalContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        borderBottom: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-quaternary']),
        alignItems: 'flex-start',
        flexWrap: 'wrap-reverse',
        pt: {
            sm: backrs.spacing['spacing-2xl'],
        },
        display: {
            xs: 'none',
            md: 'flex',
        },
        justifyContent: 'space-between',
        maxWidth: "calc(936px - ".concat(backrs.spacing['spacing-7xl'], ") !important"),
        justifyItems: 'center',
        width: '-webkit-fill-available',
        alignSelf: 'center',
        position: 'sticky',
        top: 0,
        backgroundColor: backrs.colors['Beige/25'],
        zIndex: 10,
        mx: {
            xs: backrs.spacing['spacing-4xl'],
        },
        boxSizing: 'border-box',
    });
};
var boxContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'flex-start',
        borderRadius: backrs.radius['radius-md'],
        border: "1px solid ".concat(backrs.colors['Gray/300']),
        boxShadow: backrs.shadows['shadow-xs-skeuomorphic'],
        pt: {
            sm: backrs.spacing['spacing-none'],
        },
        position: 'sticky',
        top: 0,
        width: 'fit-content',
        overflow: 'hidden',
    });
};
var minimalTabsSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        gap: backrs.spacing['spacing-md'],
        textTransform: 'none',
        flex: 1,
        '& .MuiTabs-indicator': {
            backgroundColor: backrs.colors['Colors/Foreground/fg-brand-secondary'],
        },
    });
};
var boxTabsSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        '& .MuiTabs-indicator': {
            display: 'none',
        },
        '& .MuiTab-root': {
            padding: backrs.spacing['spacing-none'],
        },
        '& .MuiButtonBase-root': {
            padding: backrs.spacing['spacing-none'],
            paddingX: {
                xs: backrs.spacing['spacing-sm'],
                lg: backrs.spacing['spacing-xl'],
            },
        },
    });
};
var chipSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        borderColor: backrs.colors['Colors/Border/border-primary'],
        borderRadius: backrs.radius['radius-md'],
        '& .MuiChip-label': {
            color: backrs.colors['Colors/Text/text-secondary'],
            display: {
                xs: 'none',
                lg: 'block',
            },
        },
        backgroundColor: backrs.colors['Colors/Background/bg-primary'],
        alignSelf: 'center',
    });
};
var filterContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        backgroundColor: backrs.colors['Colors/Background/bg-secondary-alt'],
        alignItems: 'flex-start',
        borderRadius: backrs.radius['radius-md'],
        border: "1px solid ".concat(backrs.colors['Beige/950']),
        p: backrs.spacing['spacing-xs'],
        position: 'sticky',
        top: 0,
        transition: 'none',
        zIndex: 1,
    });
};
var filterTabIndicatorSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        height: '100%',
        top: 0,
        backgroundColor: 'transparent',
        border: "1px solid ".concat(backrs.colors['Beige/950']),
        borderRadius: backrs.radius['radius-sm'],
        transition: 'left 0.3s ease, width 0.3s ease',
        zIndex: 1,
    });
};
var filterTabSx = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign(__assign({}, typography['text-sm-semibold']), { color: backrs.colors['Colors/Text/text-quaternary'], backgroundColor: backrs.colors['Colors/Base/White'], transition: 'color 0.5s ease', '&:hover': {
            backgroundColor: backrs.colors['Colors/Background/bg-primary-alt'],
            color: backrs.colors['Colors/Text/text-secondary'],
        }, textTransform: 'none', py: backrs.spacing['spacing-md'], px: backrs.spacing['spacing-lg'], minWidth: 'unset', minHeight: 'unset', '&.Mui-selected': {
            color: backrs.colors['Colors/Text/text-secondary'],
        }, marginRight: { sm: backrs.spacing['spacing-md'] }, '&:last-of-type': {
            marginRight: backrs.spacing['spacing-none'],
        } }));
};
var filterTabsSx = {
    textTransform: 'none',
    flex: 1,
    '&.MuiTabs-root': {
        minWidth: 'unset',
        minHeight: 'unset',
    },
    transition: 'none',
};
